import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SiteHeader, SiteFooter, ProfileAvatar } from './SiteLayout';
import { normalizeProfile, profilePath, profileYears } from './memoryUtils';

export default function ProfileDirectory() {
  const [profiles, setProfiles] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    fetch('/api/profiles?count=100', { signal: controller.signal })
      .then(async (response) => {
        if (!response.ok) throw new Error();
        setProfiles((await response.json()).map(normalizeProfile));
      })
      .catch((error) => {
        if (error.name !== 'AbortError') setError('Profily se nepodařilo načíst.');
      });
    document.title = 'Vzpomínkovník';
    return () => controller.abort();
  }, []);
  return (
    <>
      <SiteHeader />
      <main className="site-shell site-directory">
        <h1>Vzpomínkovník</h1>
        <p className="site-directory-intro">Vzpomínky na naše blízké.</p>
        {error ? (
          <p role="alert">{error}</p>
        ) : profiles === null ? (
          <p className="site-status">Načítám…</p>
        ) : (
          <div className="profile-directory-grid">
            {profiles.map((profile) => (
              <Link key={profile.id} to={profilePath(profile.slug)} className="profile-directory-card">
                <ProfileAvatar profile={profile} />
                <h2>{profile.name}</h2>
                {profileYears(profile) && <p>{profileYears(profile)}</p>}
              </Link>
            ))}
            {!profiles.length && <p>Zatím zde nejsou žádné profily.</p>}
          </div>
        )}
      </main>
      <SiteFooter />
    </>
  );
}
